import {Injectable} from '@angular/core';
import {StatusbarAndNavbarService} from "./statusbar-and-navbar.service";
import {translation} from "../translation";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  themes = [
    {name: translation.theme.light, value: 'light'},
    {name: translation.theme.bird, value: 'bird'},
    {name: translation.theme.blossoms, value: 'blossoms'},
    {name: translation.theme.clouds, value: 'clouds'},
    {name: translation.theme.desert, value: 'desert'},
    {name: translation.theme.field, value: 'field'},
    {name: translation.theme.geese, value: 'geese'},
    {name: translation.theme.hills, value: 'hills'},
    {name: translation.theme.lake, value: 'lake'},
    {name: translation.theme.ocean, value: 'ocean'},
    {name: translation.theme.path, value: 'path'},
    {name: translation.theme.seascape, value: 'seascape'},
    {name: translation.theme.stars, value: 'stars'},
    {name: translation.theme.thunderstorm, value: 'thunderstorm'},
    {name: translation.theme.wheat, value: 'wheat'},
    {name: translation.theme.dark, value: 'dark'},
    {name: translation.theme.black, value: 'black'}
  ];

  theme: string = 'field';

  primaryColor: string;
  darkMode: boolean = false;
  loading: boolean = true;
  constructor(private statusbarAndNavbarService: StatusbarAndNavbarService) {
    this.primaryColor = '#FFFFFF';
    this.darkMode = false;
  }

  getPrimaryColor(): string {
    return this.primaryColor;
  }

  isDarkMode(): boolean {
    return this.darkMode;
  }

  async applyTheme(theme: string, background = true, blur = false, textOutline = true, textAlignmentReadMode = 'center', textAlignmentPresentationMode = 'center') {
    document.body.classList.forEach((className) => {
      if (className.startsWith('theme-')) {
        document.body.classList.remove(className);
      }
    });

    document.body.classList.add(`theme-${theme}`);

    // Wait for a frame to ensure CSS is applied
    await new Promise(requestAnimationFrame);

    // Now extract theme information
    this.extractThemeInformation();

    // Ensure we have a valid color before proceeding
    if (!this.primaryColor || !this.primaryColor.startsWith('#')) {
      console.warn('Invalid primary color detected, using default');
      this.primaryColor = '#FFFFFF';
    }

    console.debug('Applying theme: ' + theme);
    this.theme = theme;

    if (blur) {
      document.documentElement.style.setProperty('--background-blur', "10px");
    } else {
      document.documentElement.style.removeProperty('--background-blur');
    }

    if (!background) {
      document.body.style.setProperty('--background-image', "none");
    } else {
      document.body.style.removeProperty('--background-image');
    }

    if (textOutline) {
      document.documentElement.style.setProperty('--text-outline', "0.1em");
      document.documentElement.style.setProperty('--text-outline-neg', "-0.1em");
      document.documentElement.style.setProperty('--text-outline-blur', "0.2em");
    } else {
      document.documentElement.style.setProperty('--text-outline', "0");
      document.documentElement.style.setProperty('--text-outline-neg', "0");
      document.documentElement.style.setProperty('--text-outline-blur', "0");
    }

    document.documentElement.style.setProperty('--text-alignment-read-mode', textAlignmentReadMode);
    document.documentElement.style.setProperty('--text-alignment-presentation-mode', textAlignmentPresentationMode);

    console.debug('Applying theme to statusbar and navigation bar');

    this.extractThemeInformation();
    await this.statusbarAndNavbarService.applyColor(this.primaryColor, this.darkMode);

    this.loading = false;
  }

  extractThemeInformation() {
    const bodyStyles = getComputedStyle(document.body);
    const primaryColor = bodyStyles.getPropertyValue('--primary-background').trim();
    const darkMode = bodyStyles.getPropertyValue('--dark-mode').trim() == 'true';

    // Only update if we got valid values
    if (primaryColor) {
      this.primaryColor = primaryColor;
    } else {
      console.warn('Failed to get primary color from CSS variables');
    }
    this.darkMode = darkMode;
  }
}
